// Have our Watcher observe the default slider class
DomObserver.observe('.js-default-logo', blocks => {
  blocks.forEach(block => {
    let left = 0;
    let width = 0;
    let firstItem = null;
    const resize = () => {
      width = 0;
      items.forEach(item => {
        item.style.width = 'auto';
        item.style.width = item.clientWidth + 'px';
        width += item.offsetWidth;
      });
      slider.style.width = `${width}px`;
    };
    const update = () => {
      // clearTimeout(timeout);
      requestAnimationFrame(update);
      left -= 1;
      slider.style.transform = `translateX(${left}px)`;
      if (left <= -firstItem.clientWidth) {
        left = 0;
        slider.style.transform = `translateX(${left}px)`;
        slider.removeChild(firstItem);
        slider.appendChild(firstItem);
        // Move the first item in the items array to the end
        items.push(items.shift());
        firstItem = items[0];
      }
    };

    // Find the slider
    const slider = block.querySelector('.js-default-logo__slider');
    const sliderHTML = slider.innerHTML;
    for (let i = 0; i < 5; i++) {
      slider.innerHTML += sliderHTML;
    }

    // Find all the items
    const items = [...block.querySelectorAll('.js-default-logo__item')];

    // When the block resizes we need to update the width of the slider
    const SizeObserver = new ResizeObserver(() => resize());

    // Update the first item
    firstItem = items[0];

    // Observe the block for resizing
    SizeObserver.observe(block);

    // Call the update function
    update();
  });
});